import React from "react";
import { observer } from "mobx-react";
import { partnerIcon } from "utils/Utils";
import { fn_autoFlagConfirm } from "function/FnBodySetting";

interface ProgramListItemProps {
  item: {
    configName: string;
    configUseYn: string;
  };
  rootStore: any;
}

const ProgramListItem: React.FC<ProgramListItemProps> = observer(({ item, rootStore }) => {
  const { settingStore } = rootStore;

  const handleToggle = () => {
    const val = item.configUseYn === "Y" ? "N" : "Y";
    settingStore.setSettingEachAutoProg("key", item.configName);
    settingStore.setSettingEachAutoProg("val", val);
    fn_autoFlagConfirm(rootStore, "each");
  };

  return (
    <li key={item.configName}>
      <div className="item">
        <img src={partnerIcon(item.configName)} alt={item.configName} />
        <strong>{item.configName}</strong>
        <input
          type="checkbox"
          id={`prog-toggle-${item.configName}`}
          className="inp"
          checked={item.configUseYn === "Y"}
          onChange={handleToggle}
        />
        <label className="lab_toggle" htmlFor={`prog-toggle-${item.configName}`}></label>
      </div>
    </li>
  );
});

interface ProgramListProps {
  list: Array<{
    configName: string;
    configUseYn: string;
  }>;
  rootStore: any;
}

const ProgramList: React.FC<ProgramListProps> = observer(({ list, rootStore }) => {
  if (!Array.isArray(list) || list.length === 0) {
    return null;
  }

  return (
    <ul className="list_delivery">
      {list.map(item => (
        <ProgramListItem key={item.configName} item={item} rootStore={rootStore} />
      ))}
    </ul>
  );
});

export default ProgramList;
